module.exports = __webpack_public_path__ + "img/refresh.21296b67.svg";